import { api } from '../api.ts';
import { Icon } from '../components/Icon.tsx';
import { Empty, ErpLink, ErrorBox, Loading, SourceBadge, StatusPill } from '../components/ui.tsx';
import { useLoad } from '../hooks.ts';
import { href } from '../router.ts';
import { useRefreshOn } from '../stream.tsx';
import { fmtLocal } from '../time.ts';
import { MasterNav, ReadOnlyBanner } from './MasterNav.tsx';

export function CompaniesScreen() {
  const load = useLoad((signal) => api.companies(signal), []);
  useRefreshOn(['replica'], load.reload, 800);
  const rows = (load.data ?? []).slice().sort((a, b) => a.name.localeCompare(b.name));

  return (
    <div className="page">
      <div className="page-h">
        <div>
          <h2>Companies</h2>
          <p>Customer companies from the ERP replica.</p>
        </div>
        <span className="sp" />
        <MasterNav current="companies" />
      </div>
      <ReadOnlyBanner />
      <div className="card2 flush">
        {load.error && !load.data ? (
          <ErrorBox error={load.error} onRetry={load.reload} title="Could not load companies" />
        ) : !load.data ? (
          <Loading label="Loading companies…" />
        ) : rows.length === 0 ? (
          <Empty>
            No companies yet. An admin can load them from an ERP export on the <a href={href.imports()}>Imports</a> screen.
          </Empty>
        ) : (
          <div className="tw">
            <table>
              <thead>
                <tr>
                  <th scope="col">Company</th>
                  <th scope="col">Account</th>
                  <th scope="col">Tier</th>
                  <th scope="col">Status</th>
                  <th scope="col" className="num">Sites</th>
                  <th scope="col">Source</th>
                  <th scope="col" className="num">Version</th>
                  <th scope="col">Applied</th>
                  <th scope="col">
                    <span className="sr-only">ERP</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((c) => (
                  <tr key={c.id} className={c.active ? '' : 'inactive'}>
                    <td>
                      <div className="strong">
                        <Icon name="lock" className="dim" title="ERP-owned" /> {c.name}
                      </div>
                      {c.legalName && c.legalName !== c.name && <div className="note">{c.legalName}</div>}
                      <div className="note mono">{c.id}</div>
                    </td>
                    <td className="mono">{c.accountNumber ?? '—'}</td>
                    <td>{c.tier ?? '—'}</td>
                    <td>
                      <StatusPill status={c.status} />
                      {!c.active && <span className="pill">deleted</span>}
                    </td>
                    <td className="num">
                      <a href={href.sites(c.id)} className="mono">
                        {c.siteCount}
                      </a>
                    </td>
                    <td>
                      <SourceBadge source={c.source} />
                    </td>
                    <td className="mono num">v{c.version}</td>
                    <td className="mono nowrap">{fmtLocal(c.appliedAt)}</td>
                    <td>
                      <ErpLink url={c.erpUrl} compact />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
